module.exports = require("hoist-non-react-statics");